import { cloneDeep } from 'lodash-es';
import {
  // 单选、多选国家筛选器
  COMPOSED_COUNTRY_SELECT as FILTER_COMPOSED_COUNTRY_SELECT,
  // 时间筛选器
  RANGE_TIME as FILTER_RANGE_TIME,
  // 品类筛选器
  GENRETOR as FILTER_GENRE_SELECT,
  // Mobile Overlap 筛选器
  MOBILE_OVERLAP as FILTER_MOBILE_OVERLAP,
} from '@intelligence/components/Filter/FilterBase/_config';
import { FILTER_DEFAULT_VALUE } from '@intelligence/pages/TopCharts/MobileGames/components/GamesDetails/Overlap/components/Filter/_config';

const getInitialComposedCountrySelectCountries = (
  composedCountrySelectFilterExtendCountries: string[],
  composedCountrySelectDefaultCountries: string[],
) => {
  let initialComposedCountrySelectCountriesFormValue = composedCountrySelectFilterExtendCountries?.length
    ? composedCountrySelectFilterExtendCountries
    : composedCountrySelectDefaultCountries;
  const initialComposedCountrySelectCountryFormValue = initialComposedCountrySelectCountriesFormValue?.[0] || '';
  initialComposedCountrySelectCountriesFormValue = initialComposedCountrySelectCountryFormValue
    ? [initialComposedCountrySelectCountryFormValue]
    : ['us'];
  return initialComposedCountrySelectCountriesFormValue;
};

export const getInitialFormValue = (isOperate: boolean, filterExtend: any) => {
  if (!isOperate) return cloneDeep(FILTER_DEFAULT_VALUE);

  const composedCountrySelectFilterExtend = filterExtend?.[FILTER_COMPOSED_COUNTRY_SELECT]?.value;
  const composedCountrySelectDefault = FILTER_DEFAULT_VALUE?.[FILTER_COMPOSED_COUNTRY_SELECT]?.value;
  const composedCountrySelectInitialCountries = getInitialComposedCountrySelectCountries(
    composedCountrySelectFilterExtend?.countries,
    composedCountrySelectDefault?.countries,
  );

  const rangeTimeFilterExtend = filterExtend?.[FILTER_RANGE_TIME];
  const rangeTimeFilterExtendRangeValue = rangeTimeFilterExtend?.filterValue;
  const rangeTimeDefault = FILTER_DEFAULT_VALUE?.[FILTER_RANGE_TIME];
  const rangeTimeDefaultRangeValue = rangeTimeDefault?.value;
  const rangeTimeInitialRangeValue =
    rangeTimeFilterExtendRangeValue?.length === 2 ? rangeTimeFilterExtendRangeValue : rangeTimeDefaultRangeValue;

  const genreSelectFilterExtend = filterExtend?.[FILTER_GENRE_SELECT];
  const genreSelectFilterExtendGenretor = genreSelectFilterExtend?.genretor;
  const genreSelectDefault = FILTER_DEFAULT_VALUE?.[FILTER_GENRE_SELECT];
  const genreSelectInitialSource = genreSelectFilterExtendGenretor?.source || genreSelectDefault?.source;
  const genreSelectInitialMainGenres = genreSelectFilterExtendGenretor?.mainGenres || genreSelectDefault?.mainGenres;
  const genreSelectInitialSubGenres = genreSelectFilterExtendGenretor?.subGenres || genreSelectDefault?.subGenres;

  const mobileOverlapFilterExtend = filterExtend?.[FILTER_MOBILE_OVERLAP]?.value;
  const mobileOverlapDefault = FILTER_DEFAULT_VALUE?.[FILTER_MOBILE_OVERLAP]?.value;
  const mobileOverlapInitialValue = mobileOverlapFilterExtend || mobileOverlapDefault;

  return {
    [FILTER_COMPOSED_COUNTRY_SELECT]: {
      value: {
        ...FILTER_DEFAULT_VALUE?.[FILTER_COMPOSED_COUNTRY_SELECT]?.value,
        countries: composedCountrySelectInitialCountries,
      },
    },
    [FILTER_RANGE_TIME]: {
      ...FILTER_DEFAULT_VALUE?.[FILTER_RANGE_TIME],
      value: rangeTimeInitialRangeValue,
    },
    [FILTER_GENRE_SELECT]: {
      ...FILTER_DEFAULT_VALUE?.[FILTER_GENRE_SELECT],
      source: genreSelectInitialSource,
      mainGenres: genreSelectInitialMainGenres,
      subGenres: genreSelectInitialSubGenres,
    },
    [FILTER_MOBILE_OVERLAP]: {
      value: mobileOverlapInitialValue,
    },
  };
};
